export default __webpack_public_path__ + "static/media/edit-file.f50f5967.svg";